import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'actionToText'
})
export class NotificationActionTextPipe implements PipeTransform {

  transform(value: number): string {
    const textRepresentations = [
      'Sonstige',
      'Onboarding Termin',
      'Kontakt',
      'Aufgaben',
      'Email Bestätigung',
      'Tickets'
    ];

    if (value >= 0 && value <= 9) {
      return textRepresentations[value];
    }

    return 'Unsupported Number'; // You can modify this as needed
  }

}
